import {Theme} from "@mui/material/styles";
import styled from "@mui/system/styled";
import {Grid, Typography} from "@mui/material";
import {SeverityColor} from "../constants/securspace-constants";

export const BookingCardCardContainer = styled(Grid)(() => ({
  padding: "0.8em",
  border: "1px solid rgba(238, 238, 238, 1)",
  borderRadius: "0.5em",
  position: "relative",
}));

export const BookingCardCardHeader = styled(Grid)(() => ({
  background: "rgba(63, 81, 181, 0.08)",
  padding: "0.94em 0.71em",
}));

export const BookingCardCardHeaderTitle = styled(Typography)(() => ({
  fontWeight: 500,
  fontSize: "16px",
  fontFamily: "Inter",
}));

interface BookingCardStatusLabelProps {
  theme?: Theme;
  severity: SeverityColor;
}

export const BookingCardStatusLabel = styled(Grid, {
  shouldForwardProp: propName => propName !== 'severity'
})(({theme, severity}: BookingCardStatusLabelProps) => ({
  background: theme?.palette[severity].main,
  color: "#fff",
  padding: "0.2em 0.5em",
  borderRadius: "0.2em",
  width: "fit-content",
  fontSize: "0.7rem !important",
  fontWeight: 500,
  fontFamily: "Inter",
  '& p': {
    fontSize: "0.7rem !important",
  },
  ...(severity === 'success' && {
    marginTop: '2px',
  } || {})
}));

export const BookingCardMarginTop = styled(Grid)(() => ({
  marginTop: ".2em",
}));

export const BookingCardLabel = styled(Typography)(() => ({
  color: "rgba(0, 0, 0, 0.6)",
  fontSize: "14px",
  fontWeight: 400,
  fontFamily: "Inter",
  textTransform: "uppercase",
  lineHeight: "1.43em",
  letterSpacing: "0.01em",
}));

interface BookingCardValueProps {
  theme?: Theme;
  link?: boolean;
  overagesCount?: boolean;
  severity?: SeverityColor;
}

export const BookingCardValue = styled(Typography, {
  shouldForwardProp: propName => propName !== 'link' && propName !== 'overagesCount' && propName !== 'severity'
})(({theme, link, overagesCount, severity}: BookingCardValueProps) => ({
  textTransform: "capitalize",
  fontSize: "16px",
  fontWeight: 500,
  lineHeight: "1.43em",
  letterSpacing: "0.01em",
  overflowWrap: "break-word",
  ...(severity && theme && {
    color: theme.palette[severity].main,
  }),
  ...(link && {
    color: '#3F51B5',
    cursor: 'pointer',
  }),
  ...(overagesCount && {
    color: "#FF0000",
  })
}));
